import moment from "moment";
import { fix2digit, computeTax } from "../payment/Utilities";
import {
  OutcomePriceType,
  priceTriggerType,
  RunType
} from "../../api/constants/priceTriggerEnums";
export function validPriceTriggers(PriceTriggers, usedCoupons, cartValue) {
  let nowDate = moment();
  let validPriceTriggers = PriceTriggers.filter(
    pt =>
      !pt.IsDisabled &&
      (!pt.NotApplicableWithCoupon || usedCoupons === false) &&
      (!pt.MinimumSpend || pt.MinimumSpend <= cartValue) &&
      (!pt.StartAt || (pt.StartAt && new Date(pt.StartAt) <= nowDate)) &&
      (!pt.EndAt || (pt.EndAt && new Date(pt.EndAt) >= nowDate))
  );
  return validPriceTriggers.sort((a, b) => {
    return a.Priority - b.Priority;
  });
}
export function matchConditions(
  priceTrigger,
  orderItem,
  cartItems,
  appliedQuantity,
  addQuantity = 0
) {
  //meet conditions
  var matchConditions = true;

  //ProductCategoryConditions
  if (priceTrigger.ProductCategoryConditions.length > 0) {
    for (const condition of priceTrigger.ProductCategoryConditions) {
      var totalAccur = 0;
      if (condition.ProductCategoryID) {
        cartItems.forEach(item => {
          if (
            item.ProductCategoryIDs &&
            item.ProductCategoryIDs.includes(condition.ProductCategoryID)
          )
            totalAccur += item.quantity;
        });
      }
      if (
        !orderItem.ProductCategoryIDs ||
        !orderItem.ProductCategoryIDs.includes(condition.ProductCategoryID) ||
        totalAccur + addQuantity < condition.Quantity ||
        (appliedQuantity > 0 &&
          appliedQuantity >=
            Math.floor((totalAccur + addQuantity) / condition.Quantity))
      ) {
        matchConditions = false;
      }
    }
  }
  //ProductTagConditions
  if (priceTrigger.ProductTagConditions.length > 0) {
    for (const condition of priceTrigger.ProductTagConditions) {
      totalAccur = 0;
      if (condition.ProductTagConditions) {
        cartItems.forEach(item => {
          if (
            item.ProductTagIDs &&
            item.ProductTagIDs.includes(condition.ProductTagConditions)
          )
            totalAccur += item.quantity;
        });
      }
      if (
        !orderItem.ProductTagIDs ||
        !orderItem.ProductTagIDs.includes(condition.ProductTagConditions) ||
        totalAccur + addQuantity < condition.Quantity ||
        (appliedQuantity > 0 &&
          appliedQuantity >=
            Math.floor((totalAccur + addQuantity) / condition.Quantity))
      ) {
        matchConditions = false;
      }
    }
  }
  return matchConditions;
}
export function calculateWholeOrderDiscount(
  priceTrigger,
  cartValue,
  soFarDiscount,
  priceTriggers
) {
  var rollExcludeSum = 0;
  var rollIntosExcludeWhole = priceTriggers.filter(
    pt =>
      pt.type == priceTriggerType.rollIntoMealPriceTriggers &&
      pt.selectedRollIntos &&
      pt.selectedRollIntos.length > 0 &&
      pt.Priority > priceTrigger.Priority
  );
  rollIntosExcludeWhole.forEach(rollInto => {
    rollInto.selectedRollIntos
      .filter(p => p.isConfirmed && p.selectedModifiers.length > 0)
      .forEach(innerRollInto => {
        rollExcludeSum += innerRollInto.appliedDiscount;
      });
  });

  var discount =
    (cartValue - rollExcludeSum - soFarDiscount) *
    priceTrigger.DiscountPercentageValue;
  switch (priceTrigger.OutcomePriceType) {
    case OutcomePriceType.OutcomePriceType_PercentageDiscount:
      discount =
        (cartValue - rollExcludeSum - soFarDiscount) *
        priceTrigger.DiscountPercentageValue;
      break;
    case OutcomePriceType.DiscountFlatValue:
      discount = priceTrigger.DiscountFlatValue;
      break;
    default:
      discount = 0;
  }
  return fix2digit(discount);
}
export function calculatePerItemDiscount(priceTrigger, orderitem) {
  //TODO: perItem Discount Logic will be here
  var discount = orderitem.price * priceTrigger.DiscountPercentageValue;
  switch (priceTrigger.OutcomePriceType) {
    case OutcomePriceType.OutcomePriceType_PercentageDiscount:
      discount = orderitem.price * priceTrigger.DiscountPercentageValue;
      if (priceTrigger.RunType == RunType.RunMultiple)
        discount = orderitem.quantity * discount;
      break;
    case OutcomePriceType.DiscountFlatValue:
      discount = orderitem.price - priceTrigger.DiscountFlatValue;
      break;
    default:
      discount = 0;
  }
  return fix2digit(discount);
}
export function priceTriggerDiscountsSum(priceTriggers) {
  var totalDiscount = 0;
  var wholeOrderDiscount = priceTriggers.find(
    pt => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
  );
  if (wholeOrderDiscount) {
    totalDiscount += wholeOrderDiscount.appliedDiscount;
  }
  priceTriggers
    .filter(pt => pt.type == priceTriggerType.perItemDiscountPriceTriggers)
    .forEach(element => {
      totalDiscount += element.appliedDiscount;
    });
  //TODO: sum perItem Discount
  return totalDiscount;
}
export function rollIntoPriceSum(outcomes) {
  var rolls = outcomes.filter(
    oc => oc.type == priceTriggerType.rollIntoMealPriceTriggers
  );
  var sum = 0;
  rolls
    .filter(p => p.selectedRollIntos && p.selectedRollIntos.length > 0)
    .forEach(roll => {
      roll.selectedRollIntos
        .filter(p => p.isConfirmed && p.selectedModifiers.length > 0)
        .forEach(innerRoll => {
          sum += innerRoll.appliedDiscount;
        });
    });
  return sum;
}
export function incAppliedQuantity(quantityMap, id) {
  if (quantityMap[id]) {
    quantityMap[id]++;
  } else {
    quantityMap[id] = 1;
  }
}

export function createItemAppliedPriceTriggerPart(orderItem, priceTriggers) {
  var appliedPriceTriggerRecords = [];
  priceTriggers.forEach(pt => {
    switch (pt.type) {
      case priceTriggerType.wholeOrderDiscountPriceTriggers:
        appliedPriceTriggerRecords.push({
          AffectedOrderItemQuantity: orderItem.Quantity,
          PriceTriggerID: pt.ID,
          IsResultOrderItem: false
        });
        break;
      case priceTriggerType.rollIntoMealPriceTriggers:
        if (
          pt.order == orderItem.uniqueId &&
          pt.selectedRollIntos &&
          pt.selectedRollIntos.length > 0
        ) {
          appliedPriceTriggerRecords.push({
            AffectedOrderItemQuantity: pt.selectedRollIntos.length,
            PriceTriggerID: pt.ID,
            IsResultOrderItem: true
          });
        }
        break;
      case priceTriggerType.perItemDiscountPriceTriggers:
        if (pt.order == orderItem.uniqueId) {
          appliedPriceTriggerRecords.push({
            AffectedOrderItemQuantity: orderItem.Quantity,
            PriceTriggerID: pt.ID,
            IsResultOrderItem: false
          });
        }
        break;
    }
  });
  return appliedPriceTriggerRecords;
}

export function createAppliedPriceTriggerPart(orderItems, priceTriggers) {
  var appliedPriceTrigger = [];
  priceTriggers.forEach(pt => {
    var AffectedOrderItemAndQuantity = {};
    var modifyingExcludingTax = 0;
    switch (pt.type) {
      case priceTriggerType.wholeOrderDiscountPriceTriggers:
        orderItems.forEach(orderitem => {
          AffectedOrderItemAndQuantity[orderitem.Product_ID] =
            orderitem.Quantity;
        });
        modifyingExcludingTax = pt.appliedDiscount * -1;
        break;
      case priceTriggerType.rollIntoMealPriceTriggers:
        if (pt.selectedRollIntos && pt.selectedRollIntos.length > 0) {
          orderItems.forEach(orderitem => {
            if (pt.order == orderitem.uniqueId) {
              AffectedOrderItemAndQuantity[orderitem.Product_ID] =
                pt.selectedRollIntos.length;
            }
          });
          modifyingExcludingTax = pt.FixedPriceValue;
          pt.selectedRollIntos.forEach(rollinto => {
            modifyingExcludingTax += rollinto.appliedDiscount;
          });
        }
        break;
      case priceTriggerType.perItemDiscountPriceTriggers:
        orderItems
          .filter(p => pt.order == p.uniqueId)
          .forEach(orderitem => {
            AffectedOrderItemAndQuantity[orderitem.Product_ID] =
              pt.RunType == RunType.RunMultiple ? orderitem.Quantity : 1;
          });
        modifyingExcludingTax = pt.appliedDiscount * -1;
        break;
    }
    appliedPriceTrigger.push({
      PriceTriggerID: pt.ID,
      AffectedOrderItemAndQuantity: AffectedOrderItemAndQuantity,
      AppliedQuantity: 1,
      ModifyingTax: fix2digit(
        computeTax({
          price: modifyingExcludingTax,
          taxRate: 0.1
        })
      ),
      ModifyingExcludingTax: modifyingExcludingTax
    });
  });
  return appliedPriceTrigger;
}

export function calcItemAllPriceTriggerAppliedDiscount(
  orderItem,
  priceTriggers
) {
  var totalDiscount = 0;
  priceTriggers
    .filter(
      pt =>
        (pt.type == priceTriggerType.perItemDiscountPriceTriggers ||
          pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers) &&
        pt.order == orderItem.uniqueId
    )
    .sort((a, b) => {
      return a.Priority - b.Priority;
    })
    .forEach(element => {
      if (element.type == priceTriggerType.perItemDiscountPriceTriggers)
        totalDiscount += element.appliedDiscount;
      else if (element.type == priceTriggerType.wholeOrderDiscountPriceTriggers)
        totalDiscount +=
          element.DiscountPercentageValue * (orderItem.price - totalDiscount);
    });
  return totalDiscount;
}
